import React, { useEffect, useState, useRef, useCallback } from "react";
import { Typography } from "@mui/material";
import Upadate from "src/Assets/images/update.svg";
import DownArrow from "src/Assets/images/UpButton.png";
import "./UpdateActtivity.css";
import ActivityPost from "../../ActivityPost";
import API from "../../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
// import ConfirmationDialog from "src/Components/ConfirmationDialog";

function UpdateActtivity(props) {
  const [isListOpen, setisListOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [breadCountLength, setBreadCountLength] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [completeUpdateListData, setCompleteUpdateListData] = useState({});
  const listRef = useRef(null);
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);

  const toggleList = () => {
    setisListOpen(true);
  };

  const handleScroll = useCallback(() => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  }, []);

  // const getData = (page) => {
  //   API.getUserUpdates(breadCountLength, page).then((res) => {
  //     setListData((prevList) => [...prevList, ...res.data.announcements]);
  //     setCompleteUpdateListData(res.data);
  //     setBreadCountLength(
  //       (prevBreadLength) => prevBreadLength + res.data.announcements.length
  //     );
  //   });
  // };

  const getData = async (page) => {
    try {
      setActivityLoading(true);
      const res = await API.getUserUpdates(breadCountLength, page);

      if (res?.data?.announcements && res.data.announcements.length > 0) {
        setListData((prevList) => [...prevList, ...res.data.announcements]);
        setBreadCountLength(
          (prevBreadLength) => prevBreadLength + res.data.announcements.length
        );
        setActivityLoading(false);
      } else {
        console.warn("No announcements found.");
        setActivityLoading(false);
      }

      setCompleteUpdateListData(res.data || {});
    } catch (error) {
      console.error("Error fetching data:", error);
      setActivityLoading(false);
      // alert("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (props.isCountLoading) return;
    getData(pageNumber);
  }, [props.isCountLoading, pageNumber]);

  const decreaseUpdateListCount = () => {
    setCompleteUpdateListData((prevData) => ({
      ...prevData,
      announcementsSize: prevData.announcementsSize - 1,
    }));
  };

  const onClose = () => {
    setConfModalVisible(null);
  };

  const confirmationForDelete = (id) => {
    setConfModalVisible({
      open: true,
      type: "warning",
      title: "Are you sure you want to delete this UPDATE?",
      rejectLabel: "Cancel",
      acceptLabel: "Yes",
      onReject: onClose,
      onAccept: () => deleteTag(id),
    });
  };

  const likeUnlike = (id) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.UserLikeStatus = "InActive";
    modifiedData.voteUp = modifiedData.voteUp - 1 + 2;
    setListData(newData);
  };

  const deleteTag = (id) => {
    let formdata = new FormData();
    formdata.append("messageID", id);
    API.deleteProfilePost(formdata)
      .then((res) => {
        const newList = [...listData];
        const index = newList.findIndex((x) => x.id === id);
        if (index > -1) {
          newList.splice(index, 1);
          setListData(newList);
          decreaseUpdateListCount();
          props?.decreaseActivityUpdateCount?.();
        }
        setConfModalVisible(null);
      })
      .catch((err) => {});
  };

  const updateMessage = useCallback((id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? message.match(urlRegex) || [] : [];

    setListData((prevList) =>
      prevList.map((eachItem) => {
        if (eachItem?.id === id) {
          const { newSelectedLocation, ...cleanItem } = eachItem;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
            locName: locationName || "",
            msgLat: locationName ? (lat || eachItem.msgLat || "") : "",
            msgLng: locationName ? (lng || eachItem.msgLng || "") : "",
            docName:
              attachment?.name ||
              (attachment === null ? "" : eachItem.docName || ""),
            docLocation:
              tempUrl ||
              (attachment === null ? "" : eachItem.docLocation || ""),
            docTagged:
              attachment ? 1 : attachment === null ? 0 : eachItem.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        }
        return { ...eachItem };
      })
    );
  }, []);

  useEffect(() => {
    const handlePostUpdated = (event) => {
      const { id, message, locationName, attachment, lat, lng } = event.detail || {};
      if (id) {
        updateMessage(id, message, locationName, attachment, lat, lng);
      }
    };
    window.addEventListener("postUpdated", handlePostUpdated);
    return () => {
      window.removeEventListener("postUpdated", handlePostUpdated);
    };
  }, [updateMessage]);
    // const newData = [...listData];
    // const modifiedData = newData.find((x) => x.id === id);
    // let formdata = new FormData();
    // formdata.append("messageID", id);
    // formdata.append("message", message);
    // API.updateProfilePost(modifiedData.locName, formdata)
    //   .then((res) => {
    //     modifiedData.Message = message;
    //     setListData(newData);
    //   })
    //   .catch((err) => {});

  const handleDeleteAttachementDocFromParent = (id) => {
    setListData((prevData) =>
      prevData.map((item) =>
        item.id === id
          ? { ...item, docName: null, docLocation: null, docTagged: 0 }
          : item
      )
    );
  };

  return (
    <>
      {!isListOpen && (
        <div className="UpdateActtivity" onClick={toggleList}>
          <div className="usable-container">
            <img src={Upadate} alt="Ask-icon" className="askicon" />
            <Typography className="ask">UPDATE</Typography>
          </div>
          <div className="usable-container">
            <span className="number">
              {props?.activityCountRes?.updatesListSize}
            </span>
            <img src={DownArrow} alt="DownArrow" className="DownArrow" />
          </div>
        </div>
      )}

      {isListOpen && (
        <div className="AskActivity_active">
          <div
            className="color-combination"
            onClick={() => setisListOpen(false)}
          >
            <div className="usable-container">
              <img src={Upadate} alt="Ask-icon" className="askicon" />
              <Typography className="ask">UPDATE</Typography>
            </div>
            <div className="usable-container">
              <span className="number">
                {props?.activityCountRes?.updatesListSize}
              </span>
              <img src={DownArrow} alt="DownArrow" className="DownArrow" />
            </div>
          </div>
          <div
            ref={listRef}
            onScroll={handleScroll}
            role="list"
            className="posts"
          >
            {listData && listData.length !== 0 ? (
              <ActivityPost
                listData={listData}
                updateMessage={updateMessage}
                delete={confirmationForDelete}
                likeUnlike={likeUnlike}
                pageNumber={pageNumber}
                filterType="activityUpdate"
                onHashTagClick={props.onHashTagClick}
                onDelete={deleteTag}
                postType={"UPDATE"}
                handleDeleteAttachementDocFromParent={
                  handleDeleteAttachementDocFromParent
                }
              />
            ) : (
              <div className="no-data-container">
                {activityLoading ? (
                  <CircularProgress size={25} />
                ) : (
                  <p>No Activity Updates found</p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {/* {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />} */}
    </>
  );
}

export default UpdateActtivity;
